'use strict';

/**
 * Logo
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.Logo = T.createModule({

	_eventNames: {
		toggleSearch: 'navigation-search-toggle',
		toggleFlyout: 'navigation-flyout-toggle'
	},

	_stateClasses: {
		hideSmall: 'state-hide-small'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		this._events.on(this._eventNames.toggleSearch, this.toggleSearch.bind(this));

		resolve();
	},
	toggleSearch: function toggleSearch() {
		// If the search is overlapping the logo, it should be hidden.
		this.$ctx.toggleClass(this._stateClasses.hideSmall);
	}
});